<template>
       <div class="navigation-tab">
    <div class="navigation-tab-item active" @click="onChangePage('home')">
    <home-icon class="navigation-tab__icon"/>
    <span class="navigation-tab__txt">Home</span>
  </div>
  <div class="navigation-tab-item" @click="onChangePage('product')">
    <heart-icon class="navigation-tab__icon"/>
    <span class="navigation-tab__txt">Favorite</span>
  </div>
  <div class="navigation-tab-item" @click="onChangePage('user')">
    <user-icon class="navigation-tab__icon"/>
    <span class="navigation-tab__txt">Account</span>
  </div>
</div>
</template>

<script>
import { HeartIcon, UserIcon, HomeIcon } from 'vue-feather-icons';

export default {
    name: "Bottom-tab-bar",
    components: {
        HeartIcon,
        UserIcon,
        HomeIcon
    },
    props: {
        // priceDown: {
        //     type: Number,
        //     required: false
        // },
    },
    data() {
        return {
            
        }
    },
    mounted() {
        const buttons = document.querySelectorAll(".navigation-tab-item");

        buttons.forEach(item => {

        item.addEventListener("click", function() {
            if (this.classList.contains("active")) return;
            let activeButton = document.querySelector(".navigation-tab-item.active");
            this.classList.add("active");
            
            if (activeButton) {
                activeButton.classList.remove("active");
            }
        

        });

});
    },
    computed: {
      currentCustomer() {
        return this.$store.getters.currentCustomer;
      }, 
    },
    methods: {
      onChangePage(page) {
        if (page === 'user') {
          this.$store.dispatch('getCustomerrefereLink', this.currentCustomer.id)
        }
        this.$emit('setIsChangePage', page)
      }
    },
    watch: {

    }
}
</script>

<style scoped>
.navigation-tab {
  position: fixed;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  height: 56px;
  width: 95%;
  padding: 8px;
  background-color: #1E7CE9;
  box-shadow: 0 50px 30px 0 rgba(#000, 0.175);
  border-radius: 28px;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  flex-shrink:0;
}

  .navigation-tab-item {
    display: flex;
    justify-content: center;
    gap: 12px;
    width: 25%;
    flex-shrink: 0;
    transition: 0.3s;
    border-radius: 25px;
    position: relative;
    z-index: 2;
  }

    .navigation-tab-item.active {
      background: #fff;
      width: auto;
      padding: 11px 12px;
    }
 
    .navigation-tab-item.active .navigation-tab__txt {
        opacity: 1;
        transform: translate(0, 0);
    }

    .navigation-tab-item.active .navigation-tab__icon {
        color: #1E7CE9; 
        transform: translate(0, 0);
    }

  .navigation-tab__icon {
    display: block;
    width: 18px;
    height: 18px;
    color: #fff;
    line-height: 1;
    margin: auto 0;
    transition: all .2s ease;
    transform: translateX(40px);
  }

  .navigation-tab__txt {
    display: block;
    font-family: "Comfortaa", sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px; 
    color: #1E7CE9;
    opacity: 0;
    transition-duration: 0.3s;
    transition-delay: 0.1s;
    transform: translate(0, 20px);
    user-select: none;
  }


</style>